module.exports = __webpack_public_path__ + "static/img/GOLD-COAST.876e8cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GOLD-COAST.svg
// module id = YWLr
// module chunks = 0